// extracted by mini-css-extract-plugin
export default {"page":"index_page__KST-h"};